import { Refinement } from "@siteimprove/alfa-refinement";
const { keys } = Object;
const { isArray } = Array;
const { isFunction, isObject, isString, isNumber, isBoolean, isNull } = Refinement;
/**
 * @public
 */
export var Serializable;
(function (Serializable) {
    function isSerializable(value) {
        return isObject(value) && isFunction(value.toJSON);
    }
    Serializable.isSerializable = isSerializable;
    function toJSON(value, options) {
        if (isSerializable(value)) {
            return value.toJSON(options);
        }
        if (isString(value) ||
            isNumber(value) ||
            isBoolean(value) ||
            isNull(value)) {
            return value;
        }
        if (isArray(value)) {
            return value.map((item) => toJSON(item, options));
        }
        if (isObject(value)) {
            const json = {};
            for (const key of keys(value)) {
                if (value[key] !== undefined) {
                    json[key] = toJSON(value[key], options);
                }
            }
            return json;
        }
        return null;
    }
    Serializable.toJSON = toJSON;
    let Verbosity;
    (function (Verbosity) {
        Verbosity[Verbosity["Minimal"] = 0] = "Minimal";
        Verbosity[Verbosity["Low"] = 100] = "Low";
        Verbosity[Verbosity["Medium"] = 200] = "Medium";
        Verbosity[Verbosity["High"] = 300] = "High";
    })(Verbosity = Serializable.Verbosity || (Serializable.Verbosity = {}));
})(Serializable || (Serializable = {}));
//# sourceMappingURL=serializable.js.map